module.exports = __webpack_public_path__ + "static/media/silkycloud-5.17925a89.png";